import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import dept from './modules/dept'
import project from './modules/project'
import getters from './getters'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters,
  mutations: {
  },
  actions: {
  },
  modules: {
    user,
    dept,
    project
  }
})
